/** @ng2api @module ng2 */ /** for typedoc */
export * from './providers';
export * from './uiRouterNgModule';
export * from './uiRouterConfig';
export * from './directives/directives';
export * from './statebuilders/views';
export * from './statebuilders/lazyLoad';
export * from './lazyLoad/lazyLoadNgModule';
export * from '@uirouter/core';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/angular/lib/index.js
// module id = 8
// module chunks = 1